module.exports = __webpack_public_path__ + "img/gla.a755d8a3.jpg";